import React, { useEffect, useMemo, useState } from "react";
import LinksComponent from "../../../../components/Tenant/LinksComponent/LinksComponent";
import { Menu } from "@headlessui/react";
import { HiOutlinePlus } from "react-icons/hi";
import DataTableComponent from "../../../../components/Tenant/DataTableComponent/DataTableComponent";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { toast } from "react-hot-toast";
import { GrDocumentPdf } from "react-icons/gr";
import { Link, useNavigate } from "react-router-dom";
import { hasPermission } from "../../../../utils/hasPermission";
import { getVendorName } from "../../../../utils/getVendorName";
import ImageModal from "../../../../components/Tenant/ImageModal/ImageModal";
import ModalComponent from "../../../../components/Tenant/ModalComponent/ModalComponent";
import { CgFontSpacing, CgReorder } from "react-icons/cg";
import { useEmployeeCityMapCsvMutation, useEmployeeCsvMutation, useFetchAllEmployeeMutation, useFetchEmpCityMutation, useSyncEmployeeMutation, useSyncLeftEmployeeMutation, useTransferEmployeeMutation, useUpateEmployeeMutation, useUpateEmployeeStatusMutation, useUploadEmpCityCsvMutation, useUploadEmployeeCsvMutation } from "../../../../features/tenant/Employee/employeeApi";
import { downloadSampleCSV } from "../../../../utils/downloadSampleCsv";
import { useFetchAllEmployeeLevelMutation } from "../../../../features/tenant/Employee/employeeLevelApi";
import { TbTransfer } from "react-icons/tb";
import { CircleLoaderComponent } from "../../../../components/Loader/CircleLoaderComponent";

const DetailRow = ({ label, value }) => (
  <div className="flex justify-between py-1 text-sm border-b last:border-0">
    <span className="font-medium text-gray-600">{label}</span>
    <span className="text-gray-800">{value || "-"}</span>
  </div>
);

const EmployeeList = () => {
  const navigate = useNavigate();

  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
    .color_shades;
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [cityLimit, setCityLimit] = useState(10);
  const [cityOffset, setCityOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [cityPrevPage, setCityPrevPage] = useState(0);
  const [levelList, setLevelList] = useState([]);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [parentInfo, setParentInfo] = useState({});
  const [childInfo, setChildInfo] = useState({
    name: "",
    email: "",
    user_id: "",
  });
  const [childExist, setChildExist] = useState(false);
  const [parentMobile, setParentMobile] = useState("");
  const [childMobile, setChildMobile] = useState("");
  const [allEmployeeData, setAllEmployeeData] = useState([])
  const [allEmployeeCount, setAllEmployeeCount] = useState(0)
  const [showImageModal, setShowImageModal] = useState(false);
  const [reorderModal, setReorderModal] = useState(false);
  const [csvModal, setCsvModal] = useState(false);
  const [csvCityModal, setCsvCityModal] = useState(false);
  const [file, setFile] = useState();
  const [csvFile, setCsvFile] = useState();
  const [showEditModal, setShowEditModal] = useState(false);
  const [editId, setEditId] = useState("");
  const [editName, setEditName] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [selectedEmployee,setSelectedEmployee] = useState(null);
  const [editUserId, setEditUserId] = useState("")
  const [editDesignation, setEditDesignation] = useState("");
  const [cityActionType, setCityActionType] = useState("add");
  const [cityModal, setCityModal] = useState(false)
  const [cityList, setCityList] = useState([])
  const [cityCount, setCityCount] = useState(0)
  const [showSyncLeftModal, setShowSyncLeftModal] = useState(false)
  const [citySearch,setCitySearch] = useState("")
  const initialRequest = {
    name: "",
    user_id: "",
    mobile: "",
    email: "",
    status: "",
    level_id: "",
    manager_id: ""
  };
  const [request, setRequest] = useState(initialRequest);
  const [syncLeftList, setSyncLeftList] = useState([])
  const [templateData, setTemplateData] = useState([
    {
      "name": "name",
      "label": "Sample Name",
      "maxLength": 100
    },
    {
      "name": "mobile",
      "label": "Sample Mobile",
      "maxLength": 10
    },
    {
      "name": "level_name",
      "label": "Sample Level Name",
      "maxLength": 50
    },
    {
      "name": "email",
      "label": "Sample Email",
      "maxLength": 100
    },
    {
      "name": "designation",
      "label": "Sample Designation",
      "maxLength": 100
    },
    {
      "name": "user_id",
      "label": "Sample Employee Code",
      "maxLength": 50
    },
    {
      "name": "manager_name",
      "label": "Sample Manager Name",
      "maxLength": 10
    },
    {
      "name": "manager_mobile",
      "label": "Sample Manager Mobile",
      "maxLength": 10
    }
  ]);
  const [cityTemplateData, setCityTemplateData] = useState([
    {
      "name": "mobile",
      "maxLength": 10
    },
    {
      "name": "state",
      "maxLength": 100
    },
    {
      "name": "branch_code",
      "maxLength": 100
    },
    {
      "name": "city",
      "maxLength": 100
    }
  ]);

  const [
    fetchOldManagerEmployee,
    {
      data: fetchOldManagerEmployeeData,
      isLoading: fetchOldManagerEmployeeIsLoading,
      isError: fetchOldManagerEmployeeIsError,
      error: fetchOldManagerEmployeeError,
    },
  ] = useFetchAllEmployeeMutation();

  const [
    fetchEmployeeCsv,
    {
      data: fetchEmployeeCsvData,
      isLoading: fetchEmployeeCsvIsLoading,
      isError: fetchEmployeeCsvIsError,
      error: fetchEmployeeCsvError,
    },
  ] = useEmployeeCsvMutation();

  const [
    fetchEmployeeCityMapCsv,
    {
      data: fetchEmployeeCityMapCsvData,
      isLoading: fetchEmployeeCityMapCsvIsLoading,
      isError: fetchEmployeeCityMapCsvIsError,
      error: fetchEmployeeCityMapCsvError,
    },
  ] = useEmployeeCityMapCsvMutation();

  const [
    fetchNewManagerEmployee,
    {
      data: fetchNewManagerEmployeeData,
      isLoading: fetchNewManagerEmployeeIsLoading,
      isError: fetchNewManagerEmployeeIsError,
      error: fetchNewManagerEmployeeError,
    },
  ] = useFetchAllEmployeeMutation();

  const [
    fetchAllEmployee,
    {
      data: fetchAllEmployeeData,
      isLoading: fetchAllEmployeeIsLoading,
      isError: fetchAllEmployeeIsError,
      error: fetchAllEmployeeError,
    },
  ] = useFetchAllEmployeeMutation();

  const [
    fetchEmpCityMapping,
    {
      data: fetchEmpCityMappingData,
      isLoading: fetchEmpCityMappingIsLoading,
      isError: fetchEmpCityMappingIsError,
      error: fetchEmpCityMappingError,
    },
  ] = useFetchEmpCityMutation();

  const [
    fetchAllEmployeeLevel,
    {
      data: fetchAllEmployeeLevelData,
      isLoading: fetchAllEmployeeLevelIsLoading,
      isError: fetchAllEmployeeLevelIsError,
      error: fetchAllEmployeeLevelError,
    },
  ] = useFetchAllEmployeeLevelMutation();

  const [
    updateEmployee,
    {
      data: fetchUpdateEmployeeData,
      isLoading: fetchUpdateEmployeeIsLoading,
      isError: fetchUpdateEmployeeIsError,
      error: fetchUpdateEmployeeError,
    },
  ] = useUpateEmployeeMutation();

  const [
    uploadEmployeeCsv,
    {
      data: uploadCsvEmpData,
      isLoading: uploadCsvEmpLoading,
      isError: uploadCsvEmpIsError,
      error: uploadCsvEmpError,
    },
  ] = useUploadEmployeeCsvMutation();

  const [
    syncEmployee,
    {
      data: syncEmployeeData,
      isLoading: syncEmployeeLoading,
      isError: syncEmployeeIsError,
      error: syncEmployeeError,
    },
  ] = useSyncEmployeeMutation();

  const [
    syncLeftEmployee,
    {
      data: syncLeftEmployeeData,
      isLoading: syncLeftEmployeeLoading,
      isError: syncLeftEmployeeIsError,
      error: syncLeftEmployeeError,
    },
  ] = useSyncLeftEmployeeMutation();

  const [
    uploadEmployeeMapCsv,
    {
      data: uploadCsvEmpMapData,
      isLoading: uploadCsvEmpMapLoading,
      isError: uploadCsvEmpMapIsError,
      error: uploadCsvEmpMapError,
    },
  ] = useUploadEmpCityCsvMutation();

  const [
    updateEmployeeStatus,
    {
      data: updateEmployeeStatusData,
      isLoading: updateEmployeeStatusIsLoading,
      isError: updateEmployeeStatusIsError,
      error: updateEmployeeStatusError,
    },
  ] = useUpateEmployeeStatusMutation();

  const [
    transferEmployee,
    {
      data: transferEmployeeData,
      isLoading: transferEmployeeIsLoading,
      isError: transferEmployeeIsError,
      error: transferEmployeeError,
    },
  ] = useTransferEmployeeMutation();



  const getAllEmployeeFunc = (req = request) => {
    fetchAllEmployee({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        limit: limit,
        offset: offset,
        ...req
      }
    });

    fetchAllEmployeeLevel({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    })
  }
  useEffect(() => {
    getAllEmployeeFunc()
  }, [limit, offset]);

  if (fetchAllEmployeeIsLoading) {
    toast.loading("Loading Employee List ...", {
      id: "fetchAllCata",
    });
  }
  if (fetchAllEmployeeData) {
    toast.dismiss();
  }

  const handleDelete = (row) => {
    // console.log("object",e.target);

    updateEmployeeStatus({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        id: row.id,
        status: row.status == '1' ? '0' : '1',
      },
    });
  };
  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      width: "80px",
    },
    {
      name: "Name",
      cell: (row) => (
        <div>
          <span className="font-medium text-gray-800">{row.name || "-"}</span>
        </div>
      ),
      width: "120px",
    },
    {
      name: "user id",
      cell: (row) => <div className="text-sm text-gray-600">{row.user_id || "-"}</div>,
      width: "120px",
    },
    {
      name: "Designation",
      cell: (row) => <div className="text-sm text-gray-600">{row.designation || "-"}</div>,
      width: "120px",
    },
    {
      name: "Mobile",
      cell: (row) => <div className="text-sm text-gray-700">{row.mobile || "-"}</div>,
      width: "150px",
    },
    {
      name: "Email",
      cell: (row) => <div className="text-sm text-gray-600">{row.email || "-"}</div>,
    }, {
      name: "City Count",
      cell: (row) => <div className="text-sm text-gray-600">{row?.zone_location_ids?.length || "-"}</div>,
    },
    {
      name: "Level Name",
      cell: (row) => (
        <div>
          {row.level_name ? (
            <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded">
              {row.level_name}
            </span>
          ) : (
            <span className="text-gray-400 text-xs">-</span>
          )}
        </div>
      )
    },
    {
      name: "Manager Name",
      cell: (row) => (
        <div>
          {row.manager_name ? (
            <span className="inline-block bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded">
              {row.manager_name}
            </span>
          ) : (
            <span className="text-gray-400 text-xs">-</span>
          )}
        </div>
      ),
      width: "150px",
    },
    {
      name: "Created At",
      cell: (row) => (
        <div className="text-sm text-gray-500">{row.created_at ? new Date(row.created_at).toLocaleString() : "-"}</div>
      ),
    },
    {
      name: "status",
      cell: (row) => (
        <div>
          <button
            onClick={() => handleDelete(row)}
            className={`flex justify-center items-center rounded px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow transition duration-150 ease-in-out
        ${row.status === '1'
                ? 'bg-green-600 hover:bg-green-700'
                : 'bg-red-600 hover:bg-red-700'
              }`}
          >
            {row.status === '1' ? 'Active' : 'Inactive'}
          </button>
        </div>
      ),

    },
    {
      name: "",
      cell: (row) => (
        <div>
          <button
            onClick={() => openEditModal(row)}
            className="flex justify-center items-center rounded px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow transition duration-150 ease-in-out"
            style={{ backgroundColor: primaryColor?.["700"] || "#2563eb" }}
          >
            <span className="w-full">Edit</span>
          </button>
        </div>
      )
    },
    {
      name: "",
      cell: (row) => (
        <div>
          <button
            onClick={() => {
              setSelectedEmployee(row.id)
            }}
            className="flex justify-center items-center rounded bg-red-600 px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow transition duration-150 ease-in-out hover:bg-red-700"
          >
            City List
          </button>
        </div>
      ),
    },
  ];

  const syncColumns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      width: "80px",
    },
    {
      name: "Name",
      cell: (row) => (
        <div>
          <span className="font-medium text-gray-800">{row.name || "-"}</span>
        </div>
      ),
      width: "120px",
    },
    {
      name: "user id",
      cell: (row) => <div className="text-sm text-gray-600">{row.user_id || "-"}</div>,
      width: "120px",
    },
    {
      name: "Designation",
      cell: (row) => <div className="text-sm text-gray-600">{row.designation || "-"}</div>,
      width: "120px",
    },
    {
      name: "Mobile",
      cell: (row) => <div className="text-sm text-gray-700">{row.mobile || "-"}</div>,
      width: "150px",
    },
    {
      name: "Email",
      cell: (row) => <div className="text-sm text-gray-600">{row.email || "-"}</div>,
    }
  ];

  const cityColumns = [
    {
      name: "SNo",
      cell: (row, idx) => cityOffset + Number(idx + 1),
      width: "80px",
    },
    {
      name: "Zone",
      cell: (row) => <div className="text-sm text-gray-600">{row.zone || "-"}</div>,
    },
    {
      name: "State",
      cell: (row) => (
        <div>
          <span className="font-medium text-gray-800">{row.state || "-"}</span>
        </div>
      ),
      width: "120px",
    },
    {
      name: "District",
      cell: (row) => <div className="text-sm text-gray-600">{row.district || "-"}</div>,
      width: "120px",
    },
    {
      name: "Ctiy",
      cell: (row) => <div className="text-sm text-gray-600">{row.city || "-"}</div>,
      width: "120px",
    },
    {
      name: "Branch Code",
      cell: (row) => <div className="text-sm text-gray-700">{row.branch_code || "-"}</div>,
      width: "150px",
    },
    {
      name: "Branch Name",
      cell: (row) => <div className="text-sm text-gray-600">{row.branch_name || "-"}</div>,
    }
  ];

  useEffect(()=>{
    if(selectedEmployee)
    {
      handleCityModal()
    }
  },[selectedEmployee, cityLimit, cityOffset])

  const handleCityModal = () => {
    fetchEmpCityMapping({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        limit: cityLimit,
        offset: cityOffset,
        id: selectedEmployee,
        city: citySearch
      }
    })
  }

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
  };


  const handleCityPageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * cityLimit;
    setCityOffset(newOffset);
    setCityPrevPage(pageNumber - 1);
  };

  const handleCityPerRowsChange = (newPerPage, page) => {
    setCityLimit(newPerPage);
  };


  const closeReorderListModal = () => {
    setReorderModal(false);
  }

  useEffect(() => {
    if (fetchAllEmployeeData && fetchAllEmployeeData?.body?.employee_list) {
      setAllEmployeeData(fetchAllEmployeeData.body.employee_list);
      setAllEmployeeCount(fetchAllEmployeeData.body.total_employee);
    }
  }, [fetchAllEmployeeData])

  useEffect(() => {
    if (uploadCsvEmpData && uploadCsvEmpData?.body) {
      toast.success("Employee CSV Uploaded Successfully");
      getAllEmployeeFunc();
      setCsvModal(false);
    }
    if (uploadCsvEmpError) {
      toast.error("Error in uploading Employee CSV");
    }
  }, [uploadCsvEmpData,uploadCsvEmpError])

  useEffect(() => {
    if (fetchEmployeeCityMapCsvData && fetchEmployeeCityMapCsvData?.body) {
      console.log("employee city mapping csv", fetchEmployeeCityMapCsvData.body)
      if(fetchEmployeeCityMapCsvData.body.data && fetchEmployeeCityMapCsvData.body.data.length > 0){
      downloadJsonAsCsv(fetchEmployeeCityMapCsvData.body.data, "employee_city_mapping.csv")
      }
    }
    if (fetchEmployeeCsvError) {
      toast.error("Error in Fetching Employee CSV");
    }
  }, [fetchEmployeeCityMapCsvData, fetchEmployeeCsvError])

  useEffect(() => {
    if (fetchEmployeeCsvData && fetchEmployeeCsvData?.body) {
      console.log("employee city mapping csv", fetchEmployeeCsvData.body)
      if(fetchEmployeeCsvData.body.data && fetchEmployeeCsvData.body.data.length > 0){
        downloadJsonAsCsv(fetchEmployeeCsvData.body.data, "employee_data.csv")
      }
    }
    if (fetchEmployeeCsvError) {
      toast.error("Error in Fetching Employee City CSV");
    }
  }, [fetchEmployeeCsvData, fetchEmployeeCsvError])

  useEffect(() => {
    if (uploadCsvEmpMapData && uploadCsvEmpMapData?.body) {
      toast.success("Employee Mapping CSV Uploaded Successfully");
      setCsvCityModal(false);
    }
    if (uploadCsvEmpMapError) {
      toast.error("Error in uploading Employee CSV");
    }
  }, [uploadCsvEmpMapError, uploadCsvEmpMapData])

  useEffect(() => {
    if (fetchAllEmployeeLevelData && fetchAllEmployeeLevelData?.body) {
      console.log("employee levels", fetchAllEmployeeLevelData.body);
      setLevelList(fetchAllEmployeeLevelData.body)
    }
    if (fetchAllEmployeeLevelError) {
      toast.error("Error in Fetching Employee Levels");
    }
  }, [fetchAllEmployeeLevelData, fetchAllEmployeeLevelError])

  useEffect(() => {
    if (updateEmployeeStatusData && updateEmployeeStatusData?.body) {
      toast.success("Employee Updated Successfully");
      getAllEmployeeFunc();
    }
    if (updateEmployeeStatusError) {
      toast.error("Error in updating Employee");
    }
  }, [updateEmployeeStatusData])

  useEffect(() => {
    if (fetchUpdateEmployeeData && fetchUpdateEmployeeData?.body) {
      toast.success("Employee Updated Successfully");
      setEditEmail("");
      setEditUserId("")
      setEditName("");
      setEditDesignation("");
      setShowEditModal(false);
      setEditId("")
      getAllEmployeeFunc();
    }
    if (fetchUpdateEmployeeError) {
      toast.error("Error in updating Employee");
    }
  }, [fetchUpdateEmployeeData, fetchUpdateEmployeeError])

  useEffect(() => {
    if (syncEmployeeData) {
      toast.success("Employee Synced")
    }
    if (syncEmployeeError) {
      toast.error(syncEmployeeError?.response?.data?.message || "Employee Sync Error")
    }
  }, [syncEmployeeData, syncEmployeeError])

  useEffect(() => {
    if (syncLeftEmployeeData) {
      if (syncLeftEmployeeData.body.users.length === 0) {
        toast.error("No Pending User")
      } else {
        setSyncLeftList(syncLeftEmployeeData.body.users)
        setShowSyncLeftModal(true)
      }
    }
    if (syncLeftEmployeeError) {
      toast.error(syncLeftEmployeeError?.response?.data?.message || "Employee Sync Error")
    }
  }, [syncLeftEmployeeData, syncLeftEmployeeError])

  useEffect(() => {
    if (fetchEmpCityMappingData && fetchEmpCityMappingData?.body) {
      console.log("employee city mapping", fetchEmpCityMappingData.body)
      setCityList(fetchEmpCityMappingData.body.city)
      setCityCount(fetchEmpCityMappingData.body.totalCity || 0)
      setCityModal(true)
    }
    if (fetchEmpCityMappingError) {
      toast.error("Error in fetching Employee City Mapping Data");
    }
  }, [fetchEmpCityMappingData, fetchEmpCityMappingError])

  const downloadJsonAsCsv = (
    data,
    fileName = "employee_city_mapping.csv"
  ) => {
    if (!Array.isArray(data) || data.length === 0) {
      console.error("Empty or invalid data");
      return;
    }

    // Extract headers
    const headers = Object.keys(data[0]);

    // Convert rows
    const csvRows = [
      headers.join(","), // header row
      ...data.map(row =>
        headers
          .map(field => {
            const value = row[field] ?? "";
            // escape quotes
            return `"${String(value).replace(/"/g, '""')}"`;
          })
          .join(",")
      )
    ];

    const csvString = csvRows.join("\n");

    // Create download
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };


  function parseCSV(string) {
    const csvHeader = string
      .slice(0, string.indexOf("\n"))
      .replace(/\s/g, "")
      .split(",");

    const csvRows = string.slice(string.indexOf("\n") + 1).split(/\r?\n/);

    // console.log("csvRows: ", csvRows.length, csvRows);

    const array = csvRows
      .map((row) => {
        const values = [];
        let insideQuotes = false;
        let currentField = "";

        for (let char of row) {
          if (char === "," && !insideQuotes) {
            values.push(currentField.trim());
            currentField = "";
          } else if (char === '"') {
            insideQuotes = !insideQuotes;
          } else {
            currentField += char;
          }
        }

        values.push(currentField.trim());
        return values;
      })
      .filter((values) => values.length === csvHeader.length)
      .map((values) => {
        const obj = csvHeader.reduce((object, header, index) => {
          object[header] = values[index].trim();
          return object;
        }, {});
        return obj;
      });

    return array;
  }

  const handleOnChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleCityOnChange = (e) => {
    setCsvFile(e.target.files[0]);
  };

  const handleOnSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }

    if (!file) {
      toast.error("Please select a file");
      return;
    }
    const fileReader = new FileReader();
    if (file) {
      fileReader.onload = function (event) {
        const text = event.target.result;
        let datas = parseCSV(text);
        console.log("parsed csv data", datas);

        uploadEmployeeCsv({
          token: sessionStorage.getItem("access_token"),
          tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
          body: {
            rows: datas
          }
        });

      };

      fileReader.readAsText(file);
    }
  };

  const handleOnCsvSubmit = (e, action) => {
    console.log("cityActionType", action, csvFile)
    if (!action) {
      toast.error("Please select action type");
    }
    if (e) {
      e.preventDefault();
    }

    if (!csvFile) {
      toast.error("Please select a file");
      return;
    }
    const fileReader = new FileReader();
    if (csvFile) {
      fileReader.onload = function (event) {
        const text = event.target.result;
        let datas = parseCSV(text);
        console.log("parsed csv data", datas, action);

        uploadEmployeeMapCsv({
          token: sessionStorage.getItem("access_token"),
          tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
          body: {
            rows: datas,
            type: action
          }
        });

      };

      fileReader.readAsText(csvFile);
    }
  };

  const clearFilters = () => {
    setRequest(initialRequest)
    getAllEmployeeFunc(initialRequest)
    // fetchAppUserByUserTypeFunction(initialRequest)
  };

  useEffect(() => {
    if (parentMobile.length == 10) {
      fetchOldManagerEmployee({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: {
          mobile: parentMobile,
        }
      });
    } else {
      setParentInfo({})
    }
  }, [parentMobile])

  useEffect(() => {
    if (childMobile.length == 10) {
      fetchNewManagerEmployee({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: {
          mobile: childMobile,
        }
      });
    } else {
      setChildExist(false)
      setChildInfo({
        name: "",
        email: "",
        user_id: "",
      })
    }
  }, [childMobile])

  useEffect(() => {
    if (!fetchOldManagerEmployeeData) return;
    const list = fetchOldManagerEmployeeData?.body?.employee_list;

    if (Array.isArray(list) && list.length > 0) {
      setParentInfo(list[0]);
    } else {
      toast.error("User not found");
      setParentInfo({})
    }
  }, [fetchOldManagerEmployeeData, fetchOldManagerEmployeeError]);

  useEffect(() => {
    if (!fetchNewManagerEmployeeData) return;
    const list = fetchNewManagerEmployeeData?.body?.employee_list;

    if (Array.isArray(list) && list.length > 0) {
      setChildExist(true)
      setChildInfo(list[0]);
    } else {
      toast.error("User not found");
      setChildExist(false)
      setChildInfo({
        name: "",
        email: "",
        user_id: "",
      })
    }
  }, [fetchNewManagerEmployeeData, fetchNewManagerEmployeeError]);

  useEffect(() => {
    if (transferEmployeeData) {
      toast.success("Employee Transferred Successfully");
      setParentInfo({});
      setChildExist(false)
      setChildInfo({
        name: "",
        email: "",
        user_id: "",
      })
      setParentMobile("");
      setChildMobile("")
      getAllEmployeeFunc();
      setShowTransferModal(false);
    } else {
      console.log("transferEmployeeError", transferEmployeeError);
      toast.error("Error in Transferring Employee");
    }
  }, [transferEmployeeData, transferEmployeeError]);

  const handleAccountTransfer = () => {
    transferEmployee({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        oldMobile: parentMobile,
        newMobile: childMobile,
        name: childInfo.name,
        email: childInfo.email,
        user_id: childInfo.user_id,
      }
    });
  }

  const openEditModal = (employee) => {
    setEditName(employee.name);
    setEditEmail(employee.email);
    setEditUserId(employee.user_id);
    setEditDesignation(employee.designation);
    setEditId(employee.id);
    setShowEditModal(true);
  };

  const handleEmployeeUpdate = (row) => {
    updateEmployee({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        id: editId,
        name: editName,
        email: editEmail,
        designation: editDesignation,
        user_id: editUserId
      },
    });
  }


  return (
    <>
      {" "}
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Employee List
            <LinksComponent />
          </div>
          {(
            fetchEmployeeCsvIsLoading ||
            fetchEmployeeCityMapCsvIsLoading ||
            fetchAllEmployeeIsLoading ||
            fetchEmpCityMappingIsLoading ||
            fetchAllEmployeeLevelIsLoading ||
            fetchUpdateEmployeeIsLoading ||
            uploadCsvEmpLoading ||
            syncEmployeeLoading ||
            uploadCsvEmpMapLoading ||
            updateEmployeeStatusIsLoading ||
            syncLeftEmployeeLoading ||
            transferEmployeeIsLoading
          ) && (
            <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/60 backdrop-blur-sm">
                <CircleLoaderComponent />
              </div>
            )}


          <div className="p-3 ">
            <div class="flex justify-between">
              <div className="flex justify-between items-start">
                <div className="flex gap-2">
                  <button
                    className="btn btn-outline-primary clear-both float-right  mb-2 mr-3"
                    onClick={() => {
                      setCsvModal(true);
                    }}
                  >
                    Add Employee CSV
                  </button>
                </div>
                <div className="flex gap-2 ">
                  <button
                    className="btn btn-outline-primary clear-both float-right  mb-2 mr-3"
                    onClick={() => {
                      setCsvCityModal(true);
                    }}
                  >
                    Add Employee City Mapping CSV
                  </button>
                </div>
                <div className="flex gap-2">
                  <button
                    className="btn btn-outline-primary clear-both float-right  mb-2 mr-3"
                    onClick={() => {
                      fetchEmployeeCsv({
                        token: sessionStorage.getItem("access_token"),
                        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
                      })
                      // setCsvCityModal(true);
                    }}
                  >
                   Employee Csv
                  </button>
                </div>
                <div className="flex gap-2">
                  <button
                    className="btn btn-outline-primary clear-both float-right  mb-2 mr-3"
                    onClick={() => {
                      fetchEmployeeCityMapCsv({
                        token: sessionStorage.getItem("access_token"),
                        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
                        type: "app"
                      })
                      // setCsvCityModal(true);
                    }}
                  >
                    Employee City Map Csv
                  </button>
                </div>
                {
                  JSON.parse(sessionStorage.getItem("vendorTheme"))?.theme?.sync_app_users ? (
                    <>
                      <div className="flex gap-2">
                        <button
                          className="btn btn-outline-primary clear-both float-right  mb-2 mr-3"
                          onClick={() => {
                            syncEmployee({
                              token: sessionStorage.getItem("access_token"),
                              tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
                              type: "app"
                            })
                            // setCsvCityModal(true);
                          }}
                        >
                          Sync to App
                        </button>
                      </div>
                      <div className="flex gap-2">
                        <button
                          className="btn btn-outline-primary clear-both float-right  mb-2 mr-3"
                          onClick={() => {
                            syncLeftEmployee({
                              token: sessionStorage.getItem("access_token"),
                              tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
                              type: "app"
                            })
                            // setCsvCityModal(true);
                          }}
                        >
                          Sync Pending List
                        </button>
                      </div>
                    </>
                  ) : <></>
                }
                {
                  JSON.parse(sessionStorage.getItem("vendorTheme"))?.theme?.sync_panel_users ? (
                    <div className="flex gap-2">
                      <button
                        className="btn btn-outline-primary clear-both float-right  mb-2"
                        onClick={() => {
                          // setCsvCityModal(true);
                        }}
                      >
                        Sync to Panel
                      </button>
                    </div>
                  ) : <></>
                }
              </div>
            </div>
          </div>
          <div className="p-3">
            <div className="p-3 w-full bg-white shadow rounded-lg">
              <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                <div className="flex  space-x-2 justify-end">
                  <div className="w-52 h-10 ">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Mobile
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Mobile..."
                        required
                        value={request.mobile}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, mobile: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-52 h-10 ">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Name
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Name..."
                        required
                        value={request.name}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, name: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-52 h-10 ">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Email
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Email..."
                        required
                        value={request.email}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, email: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="w-52 h-10 ">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        User Id
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="User Id..."
                        required
                        value={request.user_id}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, user_id: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="w-52 h-10">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        User Status
                      </label>
                      <select
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        name="User Scanned"
                        //   value={request.status}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, status: newValue };
                          });
                        }}
                        id=""
                      >
                        <option selected value={""}>
                          All
                        </option>
                        <option value={"1"}>
                          Active
                        </option>
                        <option value={"2"}> Inactive</option>
                      </select>
                    </div>
                  </div>

                  <div className="w-52 h-10">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Level
                      </label>
                      <select
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        name="User Scanned"
                        //   value={request.status}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, level_id: newValue };
                          });
                        }}
                        id=""
                      >
                        <option selected value={""}>
                          All
                        </option>
                        {
                          levelList && levelList.length > 0 && levelList.map((level) =>
                            <option value={level.id}>
                              {level.level_name}
                            </option>
                          )
                        }
                      </select>
                    </div>
                  </div>


                  <div className="flex flex-row  gap-2 h-10">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        &nbsp;
                      </label>
                      <button
                        className="btn btn-outline-primary clear-both float-right  p-2"
                        onClick={() => {
                          getAllEmployeeFunc(request);
                          // fetchAppUserByUserTypeFunction();
                          // fetchAppUserByUserTypeCsvFunction();
                        }}
                      >
                        Search
                      </button>
                    </div>
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        &nbsp;
                      </label>
                      <button
                        className="btn btn-outline-primary clear-both float-right p-2"
                        onClick={() => {
                          clearFilters();
                        }}
                      >
                        Clear Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={columns}
                data={
                  allEmployeeData
                }
                // loading={loading}
                totalRows={
                  allEmployeeCount
                }
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              >
                <div className="flex m-2 space-x-2 justify-end"></div>
              </DataTableComponent>
              <div
                className="fixed bottom-0 right-10 w-16 h-16 mr-10 mb-6 cursor-pointer"
                id="box_btn"
              >
                <div className="text-right">
                  <Menu className="relative inline-block text-left">
                    <div>
                      <Menu.Button
                        onClick={() => setShowTransferModal(true)}
                        className="inline-flex justify-cente w-12 h-12 rounded-full text-sm font-medium text-white hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 "
                        style={{ backgroundColor: `${primaryColor["700"]}` }}
                      >
                        <TbTransfer className="w-full h-full p-3" />
                      </Menu.Button>
                    </div>
                  </Menu>
                </div>

              </div>
              {showImageModal && (
                <ImageModal
                  show={showImageModal ? true : false}
                  setShow={setShowImageModal}
                  size="md"
                  data={showImageModal}
                >
                  <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
                    <img
                      src={showImageModal}
                      className=" w-full object-cover object-center group-hover:opacity-75 h-40 max-w-full max-h-full"
                    />
                  </div>
                </ImageModal>
              )}

              {csvModal && (
                <ModalComponent show={csvModal} setShow={setCsvModal} size="md">
                  <div className="w-full p-4">
                    {templateData && templateData?.length > 0 && (
                      <div className="flex justify-center mt-3 ">
                        <button
                          type="submit"
                          className="mb-3 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                          onClick={() => downloadSampleCSV(templateData)}
                        >
                          Sample Csv Download
                        </button>
                      </div>
                    )}
                    <div className="w-full m-auto  justify-center ">
                      <div className="flex items-center justify-center w-full">
                        <label
                          for="dropzone-file"
                          className="flex flex-col items-center justify-center w-full h-20 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50   hover:bg-gray-100  "
                        >
                          <div className="flex flex-col items-center justify-center ">
                            <svg
                              aria-hidden="true"
                              className="w-20 h-20 mb-3 text-gray-400 mt-2"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                stroke-linecap="round"
                                strokeLinejoin="round"
                                stroke-width="2"
                                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                              ></path>
                            </svg>
                            <p className="mb-2 text-sm text-gray-500 text-center">
                              <span className="font-semibold">Choose CSV file</span>
                              <div>Click to upload or drag and drop</div>
                            </p>
                          </div>
                          <input
                            id="dropzone-file"
                            type="file"
                            className="hidden"
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            onChange={handleOnChange}
                          />
                        </label>
                      </div>
                    </div>
                    {templateData && templateData?.length > 0 ? (
                      <div className="flex justify-center mt-3">
                        <button
                          type="submit"
                          className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                          onClick={(e) => handleOnSubmit()}
                        >
                          Add
                        </button>
                      </div>
                    ) : (
                      <div className="text-red-500 rounded-lg text-sm px-5 py-2.5 text-center ">
                        No Template Found !
                      </div>
                    )}
                  </div>
                </ModalComponent>
              )}

              {csvCityModal && (
                <ModalComponent show={csvCityModal} setShow={()=>{
                  setCsvCityModal(false);
                  setSelectedEmployee("");
                  setCitySearch("")
                }} size="md">
                  <div className="w-full p-4">
                    {/* Dropdown for Add/Remove */}
                    <div className="mb-4 flex justify-center">
                      <select
                        value={cityActionType}
                        onChange={(e) => setCityActionType(e.target.value)}
                        className="border rounded px-3 py-2 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                      >
                        <option value="">Select Action</option>
                        <option value="add">Add City</option>
                        <option value="remove">Remove City</option>
                      </select>
                    </div>

                    {templateData && templateData?.length > 0 && (
                      <div className="flex justify-center mt-3 ">
                        <button
                          type="button"
                          className="mb-3 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                          onClick={() => downloadSampleCSV(cityTemplateData)}
                        >
                          Sample CSV Download
                        </button>
                      </div>
                    )}

                    {/* CSV Upload */}
                    <div className="w-full m-auto justify-center ">
                      <div className="flex items-center justify-center w-full">
                        <label
                          htmlFor="dropzone-file"
                          className="flex flex-col items-center justify-center w-full h-20 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                        >
                          <div className="flex flex-col items-center justify-center">
                            <svg
                              aria-hidden="true"
                              className="w-20 h-20 mb-3 text-gray-400 mt-2"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                              ></path>
                            </svg>
                            <p className="mb-2 text-sm text-gray-500 text-center">
                              <span className="font-semibold">Choose CSV file</span>
                              <div>Click to upload or drag and drop</div>
                            </p>
                          </div>
                          <input
                            id="dropzone-file"
                            type="file"
                            className="hidden"
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            onChange={handleCityOnChange}
                          />
                        </label>
                      </div>
                    </div>

                    {/* Add Button */}
                    {templateData && templateData?.length > 0 ? (
                      <div className="flex justify-center mt-3">
                        <button
                          type="submit"
                          className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                          onClick={(e) => handleOnCsvSubmit(e, cityActionType)}
                        >
                          {cityActionType === "remove" ? "Remove" : "Add"}
                        </button>
                      </div>
                    ) : (
                      <div className="text-red-500 rounded-lg text-sm px-5 py-2.5 text-center">
                        No Template Found!
                      </div>
                    )}
                  </div>
                </ModalComponent>
              )}

              {cityModal && (
                <ModalComponent
                  show={cityModal}
                  setShow={() => {
                    setCityModal(false);
                    setCityList([]);
                    setCityCount(0)
                  }}
                  size="4xl"
                >
                  <div className="p-6 flex flex-col gap-4">

                    {/* Header */}
                    <div className="flex justify-between items-center border-b pb-3">
                      <h2 className="text-lg font-semibold text-gray-800">
                        Employee City Mapping
                      </h2>
                    </div>

                    {/* Search */}
                    <div className="flex gap-3 items-center">
                      <input
                        type="text"
                        placeholder="Search city..."
                        className="w-full border rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        onChange={(e) => setCitySearch(e.target.value)}
                      />
                      <button
                        onClick={()=>handleCityModal()}
                        className="px-4 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 transition"
                      >
                        Search
                      </button>
                    </div>

                    {/* Table */}
                    <div className="overflow-y-auto max-h-[60vh] border rounded">
                      <DataTableComponent
                        keyField={(row) => row.SNo}
                        columns={cityColumns}
                        data={cityList}
                        totalRows={
                          cityCount || 0
                        }
                        handlePerRowsChange={handleCityPerRowsChange}
                        handlePageChange={handleCityPageChange}
                      />
                    </div>

                    {/* Footer */}
                    <div className="flex justify-end gap-3 pt-3 border-t">
                      <button
                        onClick={() => {
                          setCityModal(false);
                          setCityList([]);
                          setCityCount(0)
                        }}
                        className="px-4 py-2 text-sm text-gray-700 border rounded hover:bg-gray-100"
                      >
                        Close
                      </button>
                    </div>

                  </div>
                </ModalComponent>

              )}

              {showSyncLeftModal && (
                <ModalComponent
                  show={showSyncLeftModal}
                  setShow={() => {
                    setShowSyncLeftModal(false);
                    setSyncLeftList([]);
                  }}
                  size="4xl"
                >
                  <div className="p-6">

                    {/* Header */}
                    <div className="flex justify-between items-center mb-4">
                      <h2 className="text-lg font-semibold">Sync Left User</h2>
                      <button
                        onClick={() => {
                          setShowSyncLeftModal(false);
                          setSyncLeftList([]);
                        }}
                        className="text-gray-500 hover:text-gray-700 text-lg font-bold"
                      >
                        ✕
                      </button>
                    </div>

                    {/* Body */}
                    <div className="overflow-y-auto max-h-[70vh]">
                      <DataTableComponent
                        keyField={(row) => row.SNo}
                        columns={syncColumns}
                        data={syncLeftList}
                        pagination={false}
                        totalRows={syncLeftList?.length || 0}
                      />
                    </div>

                    {/* Footer */}
                    <div className="flex justify-end mt-4 gap-3">
                      <button
                        onClick={() => {
                          setShowSyncLeftModal(false);
                          setSyncLeftList([]);
                        }}
                        className="px-4 py-2 text-gray-700 border rounded hover:bg-gray-100"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </ModalComponent>
              )}


              {showTransferModal && (
                <ModalComponent
                  size={"xl"}
                  show={showTransferModal}
                  setShow={setShowTransferModal}
                >
                  <div className="bg-white p-6 rounded-xl shadow-xl">
                    <h2 className="text-xl font-semibold text-gray-800 mb-6">
                      Transfer Employee
                    </h2>

                    {/* ======================== OLD EMPLOYEE ======================== */}
                    <div className="border rounded-lg p-4 shadow-sm bg-gray-50 mb-6">
                      <h3 className="text-md font-bold text-blue-700 mb-2">Old Employee Details</h3>

                      <label className="text-sm text-gray-600">Mobile Number</label>
                      <input
                        type="text"
                        maxLength={10}
                        value={parentMobile}
                        onChange={(e) => setParentMobile(e.target.value)}
                        placeholder="Enter Old Employee Mobile Number"
                        className="w-full mt-1 mb-3 border rounded-md px-3 py-2 
            focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none"
                      />

                      {/* Display Existing Old Employee Details */}
                      {!!Object.keys(parentInfo).length && (
                        <div className="rounded-md bg-white p-3 border">
                          <DetailRow label="Name" value={parentInfo?.name} />
                          <DetailRow label="Email" value={parentInfo?.email} />
                          <DetailRow label="Phone" value={parentInfo?.mobile} />
                          <DetailRow label="User ID" value={parentInfo?.user_id} />
                        </div>
                      )}
                    </div>

                    {/* ======================== NEW EMPLOYEE ======================== */}
                    <div className="border rounded-lg p-4 shadow-sm bg-gray-50">
                      <h3 className="text-md font-bold text-green-700 mb-2">New Employee Details</h3>

                      <label className="text-sm text-gray-600">Mobile Number</label>
                      <input
                        type="text"
                        maxLength={10}
                        value={childMobile}
                        onChange={(e) => setChildMobile(e.target.value)}
                        placeholder="Enter New Employee Mobile Number"
                        className="w-full mt-1 mb-3 border rounded-md px-3 py-2 
            focus:border-green-500 focus:ring-1 focus:ring-green-500 outline-none"
                      />

                      {/* Case 1: Same number as old employee */}
                      {childMobile && childMobile === parentMobile && (
                        <p className="text-sm text-red-600 mt-1">
                          New employee number cannot be the same as old employee number.
                        </p>
                      )}

                      {/* Case 2: New employee ALREADY EXISTS -> Block transfer */}
                      {!!childExist && !fetchNewManagerEmployeeIsLoading && (
                        <div className="mt-2 p-3 bg-red-50 border border-red-300 rounded-md">
                          <p className="text-sm text-red-800 font-medium">
                            A user already exists with this mobile number.
                            You cannot transfer the account to an existing user.
                          </p>

                          <div className="rounded-md bg-white p-3 border mt-2">
                            <DetailRow label="Name" value={childInfo?.name} />
                            <DetailRow label="Email" value={childInfo?.email} />
                            <DetailRow label="Phone" value={childInfo?.mobile} />
                            <DetailRow label="User ID" value={childInfo?.user_id} />
                          </div>
                        </div>
                      )}

                      {/* Case 3: New employee DOES NOT exist -> Optional new employee fields */}
                      {!childExist &&
                        childMobile.length === 10 &&
                        !fetchNewManagerEmployeeIsLoading && (
                          <div className="mt-3 p-3 bg-yellow-50 border border-yellow-300 rounded-md">
                            <p className="text-sm text-yellow-800 mb-2">
                              No existing user found. A new employee account will be created.
                            </p>

                            <div className="space-y-3">
                              {/* Name */}
                              <div>
                                <label className="text-sm text-gray-600">Name (optional)</label>
                                <input
                                  type="text"
                                  value={childInfo?.name}
                                  onChange={(e) => setChildInfo((prev) => ({ ...prev, name: e.target.value }))}
                                  placeholder="Enter Name"
                                  className="w-full mt-1 border rounded-md px-3 py-2 
                      focus:border-green-500 focus:ring-1 focus:ring-green-500 outline-none"
                                />
                              </div>

                              {/* Email */}
                              <div>
                                <label className="text-sm text-gray-600">Email (optional)</label>
                                <input
                                  type="email"
                                  value={childInfo?.email}
                                  onChange={(e) => setChildInfo((prev) => ({ ...prev, email: e.target.value }))}
                                  placeholder="Enter Email"
                                  className="w-full mt-1 border rounded-md px-3 py-2 
                      focus:border-green-500 focus:ring-1 focus:ring-green-500 outline-none"
                                />
                              </div>

                              {/* User ID */}
                              <div>
                                <label className="text-sm text-gray-600">User ID (optional)</label>
                                <input
                                  type="text"
                                  value={childInfo?.user_id}
                                  onChange={(e) => setChildInfo((prev) => ({ ...prev, user_id: e.target.value }))}
                                  placeholder="Enter User ID"
                                  className="w-full mt-1 border rounded-md px-3 py-2 
                      focus:border-green-500 focus:ring-1 focus:ring-green-500 outline-none"
                                />
                              </div>
                            </div>
                          </div>
                        )}
                    </div>

                    {/* ======================== FOOTER BUTTONS ======================== */}
                    <div className="flex justify-end gap-3 mt-6">
                      <button
                        onClick={() => setShowTransferModal(false)}
                        className="px-4 py-2 text-sm text-gray-700 border rounded hover:bg-gray-100 transition"
                      >
                        Cancel
                      </button>

                      <button
                        onClick={() => handleAccountTransfer()}
                        disabled={
                          !Object.keys(parentInfo).length || // Old employee must exist
                          !childMobile ||
                          childMobile === parentMobile ||
                          childExist // New employee must NOT exist
                        }
                        className={`px-4 py-2 text-sm text-white rounded transition 
            ${!Object.keys(parentInfo).length ||
                            !childMobile ||
                            childMobile === parentMobile ||
                            childExist
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-blue-600 hover:bg-blue-700"
                          }
          `}
                      >
                        Transfer Account
                      </button>
                    </div>
                  </div>
                </ModalComponent>
              )}

              {showEditModal && (
                <ModalComponent
                  size={"md"}
                  show={showEditModal}
                  setShow={setShowEditModal}
                >
                  <div className="bg-white p-6 rounded-xl shadow-xl min-w-[400px]">
                    <h2 className="text-xl font-semibold text-gray-800 mb-6">
                      Edit Employee
                    </h2>

                    {/* ================= FORM FIELDS ================= */}
                    <div className="space-y-4">

                      {/* Name */}
                      <div>
                        <label className="text-sm text-gray-600">Name</label>
                        <input
                          type="text"
                          value={editName}
                          onChange={(e) => setEditName(e.target.value)}
                          className="w-full mt-1 border rounded-md px-3 py-2 
              focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none"
                          placeholder="Enter Name"
                        />
                      </div>

                      <div>
                        <label className="text-sm text-gray-600">User Id</label>
                        <input
                          type="text"
                          value={editUserId}
                          onChange={(e) => setEditUserId(e.target.value)}
                          className="w-full mt-1 border rounded-md px-3 py-2 
              focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none"
                          placeholder="Enter Name"
                        />
                      </div>

                      {/* Email */}
                      <div>
                        <label className="text-sm text-gray-600">Email</label>
                        <input
                          type="email"
                          value={editEmail}
                          onChange={(e) => setEditEmail(e.target.value)}
                          className="w-full mt-1 border rounded-md px-3 py-2 
              focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none"
                          placeholder="Enter Email"
                        />
                      </div>

                      {/* Designation */}
                      <div>
                        <label className="text-sm text-gray-600">Designation</label>
                        <input
                          type="text"
                          value={editDesignation}
                          onChange={(e) => setEditDesignation(e.target.value)}
                          className="w-full mt-1 border rounded-md px-3 py-2 
              focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none"
                          placeholder="Enter Designation"
                        />
                      </div>

                    </div>

                    {/* ================= FOOTER BUTTONS ================= */}
                    <div className="flex justify-end gap-3 mt-6">
                      <button
                        onClick={() => setShowEditModal(false)}
                        className="px-4 py-2 text-sm text-gray-700 border rounded hover:bg-gray-100 transition"
                      >
                        Cancel
                      </button>

                      <button
                        onClick={(row) => handleEmployeeUpdate(row)}
                        disabled={!editName || !editEmail || !editDesignation}
                        className={`px-4 py-2 text-sm text-white rounded transition 
            ${!editName || !editEmail || !editDesignation
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-blue-600 hover:bg-blue-700"
                          }
          `}
                      >
                        Save Changes
                      </button>
                    </div>
                  </div>
                </ModalComponent>
              )}



            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeList;
